(function(){
  function fmt(n){ var s=String(Math.round(n)); var out=''; var c=0; for(var i=s.length-1;i>=0;i--){ out=s.charAt(i)+out; if(++c%3===0 && i>0) out='.'+out; } return '$'+out+',00'; }
  function applyPrice(card, cents){
    if(!cents) return;
    var list = Math.round(cents/100);
    var cashEl = card.querySelector('.pep__cash');
    if(cashEl){
      cashEl.textContent = fmt(Math.round(list*0.8));
      var listEl = card.querySelector('.pep__list'); if(listEl) listEl.textContent = 'Lista ' + fmt(list);
      var cuotaEl = card.querySelector('.pep__cuota'); if(cuotaEl) cuotaEl.innerHTML = '6 cuotas sin interés de <b>' + fmt(Math.round(list/6)) + '</b>';
    } else {
      var nowEl = card.querySelector('.pep__now');
      if(nowEl) nowEl.textContent = card.querySelector('.pep__maytag') ? fmt(Math.round(list*0.75)) : fmt(list);
    }
  }
  document.addEventListener('click', function(e){
    var chip = e.target.closest('.pep__chip');
    if(chip){
      if(chip.disabled) return;
      var card = chip.closest('.pep'); if(!card) return;
      card.querySelectorAll('.pep__chip').forEach(function(c){ c.classList.remove('is-active'); });
      chip.classList.add('is-active');
      var form = card.querySelector('.pep__form');
      if(form){ var idIn = form.querySelector('[name=id]'); if(idIn) idIn.value = chip.getAttribute('data-vid'); }
      var cents = parseInt(chip.getAttribute('data-cents')||'0',10);
      if(cents){ applyPrice(card, cents); }
      else { var now = card.querySelector('.pep__now'); var pr = chip.getAttribute('data-price'); if(now && pr){ now.textContent = pr; } }
      var im = chip.getAttribute('data-img');
      if(im){ var m1 = card.querySelector('.pep__img--1'); if(m1) m1.src = im; var m2 = card.querySelector('.pep__img--2'); if(m2) m2.src = im; }
      return;
    }
    var q = e.target.closest('.pep__q');
    if(q){
      var wrap = q.parentNode; var input = wrap.querySelector('.pep__qinput'); if(!input) return;
      var val = parseInt(input.value, 10); if(isNaN(val)) val = 1;
      if(q.classList.contains('pep__q--plus')) val++; else val = Math.max(1, val - 1);
      input.value = val; return;
    }
  });
  document.addEventListener('submit', function(e){
    var form = e.target.closest('.pep__form'); if(!form) return;
    e.preventDefault();
    var btn = form.querySelector('.pep__cart'); if(btn && btn.disabled) return;
    var fd = new FormData(form);
    if(btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', { method:'POST', headers:{'Accept':'application/json'}, body: fd })
      .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
      .then(function(){ return fetch('/cart.js', { headers:{'Accept':'application/json'} }).then(function(r){ return r.json(); }); })
      .then(function(cart){
        var bubble = document.querySelector('.pe-hd__count');
        if(bubble){ bubble.textContent = cart.item_count; }
        else { var cl = document.querySelector('.pe-hd__cart'); if(cl){ var s = document.createElement('span'); s.className='pe-hd__count'; s.textContent = cart.item_count; cl.appendChild(s); } }
        if(btn){ btn.classList.remove('is-loading'); btn.classList.add('is-done'); setTimeout(function(){ btn.classList.remove('is-done'); }, 1400); }
        document.dispatchEvent(new CustomEvent('pe:cart:added'));
      })
      .catch(function(){ if(btn) btn.classList.remove('is-loading'); form.submit(); });
  });
})();
